import React from 'react';

import { NotificationType } from '../../../types';

import CollaborationInviteNotification from './NotificationTypes/CollaborationInviteNotification';
import CommentMentionNotification from './NotificationTypes/CommentMentionNotification';
import CommentNotification from './NotificationTypes/CommentNotification';
import DesignNotification from './NotificationTypes/DesignNotification';
import MessageNotification from './NotificationTypes/MessageNotification';
import ProjectCommentNotification from './NotificationTypes/ProjectCommentNotification';
import TemplateNotification from './NotificationTypes/TemplateNotification';
import WorkHighlightNotification from './NotificationTypes/WorkHighlightNotification';
import { NotificationsRendererProps } from './types';

const NotificationsRenderer: React.FC<NotificationsRendererProps> = ({
  notifications,
  setReadNotification,
  handleDeleteNotification,
}) => {
  if (!notifications?.length) {
    return null;
  }

  return (
    <>
      {notifications.map((n) => {
        switch (n.type) {
          case NotificationType.ADDED_TEMPLATES:
            return (
              <TemplateNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                notification={n}
                onReadNotification={setReadNotification}
              />
            );
          case NotificationType.TRENDING_TEMPLATES:
            return (
              <WorkHighlightNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                notification={n}
                onReadNotification={setReadNotification}
              />
            );
          case NotificationType.DESIGN_COMMENT:
            return (
              <CommentNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                notification={n}
                onReadNotification={setReadNotification}
              />
            );
          case NotificationType.COMMENT_MENTION:
            return (
              <CommentMentionNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                notification={n}
                onReadNotification={setReadNotification}
              />
            );
          case NotificationType.FOLLOW:
            return (
              <MessageNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                notification={n}
                onReadNotification={setReadNotification}
              />
            );
          case NotificationType.LIKE:
          case NotificationType.BOOKMARK:
            return (
              <DesignNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                headline={
                  n.type === NotificationType.LIKE
                    ? 'liked your design'
                    : 'saved your design'
                }
                notification={n}
                onReadNotification={setReadNotification}
              />
            );
          case NotificationType.DESIGN_SHARED:
            return (
              <DesignNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                headline="shared a design with you"
                link={n.data.link}
                notification={n}
                previewImage={`api/${n.data.objectName}`}
                onReadNotification={setReadNotification}
              />
            );
          case NotificationType.TEMPLATE_FEATURED:
            return (
              <DesignNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                headline="Your design got featured"
                notification={n}
                text="Congrats! Your design was chosen to be featured in the design gallery."
                onReadNotification={setReadNotification}
              />
            );
          case NotificationType.DESIGN_UPVOTE:
            return (
              <DesignNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                headline="upvoted your design"
                notification={n}
                text="Congrats! You got a new vote. Share your design to win the challenge."
                onReadNotification={setReadNotification}
              />
            );
          case NotificationType.PRESENTATION_THREAD:
          case NotificationType.PRESENTATION_THREAD_COMMENT:
          case NotificationType.PROJECT_THREAD:
          case NotificationType.PROJECT_THREAD_COMMENT:
            return (
              <ProjectCommentNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                notification={n}
                onReadNotification={setReadNotification}
              />
            );
          case NotificationType.COLLABORATION_INVITE:
            return (
              <CollaborationInviteNotification
                key={n.id}
                handleDeleteNotification={handleDeleteNotification}
                notification={n}
                onReadNotification={setReadNotification}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
};

export default NotificationsRenderer;
